// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_i5i0h clearfix","throughColumnAd2":"index_throughColumnAd2_41Dnn"};